module.exports = __webpack_public_path__ + "media/src/images/icons/flags/europe_union-88d0a1e00548705c6cec0bde2a7fd451.svg";